// extracted by mini-css-extract-plugin
export default {"Summary":"styles_Summary__HzGUg","latestSummary":"styles_latestSummary__uUp7V"};